import { useEffect, useRef, useState } from "react";
import axiosInstance from "../../utilities/Axios";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Formik } from "formik";
import * as Yup from "yup";
import { Button, FormHelperText, InputLabel, TextField } from "@mui/material";
import { EDialogAction } from "../Enum/DialogActionEnum";
import { useSnackbar } from "notistack";
import { useTheme } from "../../Hooks/ThemeContext/ThemeContext";

const TicketDialogBox = (props: {
  open: boolean;
  onClose: any;
  data: any;
  dialogAction: EDialogAction;
}) => {
  const [ticket, setTicket] = useState(props.data);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const theme = useTheme();
  const formRef = useRef<any>();

  useEffect(() => {
    setTicket(props.data);
  }, [props.data]);


  const handleClose = (action: string = "closed") => {
    props.onClose(action);
  };

  const createTicket = async (data: any) => {
    try {
      const url = `${process.env.REACT_APP_API_ORIGIN}/v1/ticket`;

      const res = await axiosInstance.post(url, {
        passport_no: data.passport_no,
        first_name: data.first_name,
        last_name: data.last_name,
        note: data.note,
        status: data.status,
        type_dom_corp: theme.theme,
      });
      enqueueSnackbar("Ticket Created Successfully!!!", { variant: "success" });
      handleClose("created");

    } catch (err: any) {
      enqueueSnackbar(`Ticket Creation Failed!!! ${err.response.data.error}`, {
        variant: "error",
      });
      console.error(err);
    }
  };
  const editTicket = async (data: any) => {

    const url = `${process.env.REACT_APP_API_ORIGIN}/v1/ticket/${ticket.id}`;

    axiosInstance
      .put(url, {
        status: data.status,
      })
      .then((response) => {
        enqueueSnackbar("Ticket Updated Successfully!!!");
      })
      .catch((err: any) => {
        enqueueSnackbar(
          `Ticket Updatation Unsuccessfull!!!! ${err.response.data.error}`,
          {
            variant: "error",
          }
        );
      });

    handleClose();
  };

  return (
    <>
      {" "}
      {ticket == null ? (
        <div></div>
      ) : (
        <Dialog
          open={props.open}
          onClose={(event, reason) => {
            if (reason != "backdropClick" && reason != "escapeKeyDown") {
              handleClose();
            }
          }}
        >
          {props.dialogAction == EDialogAction.edit ? (
            <DialogTitle>Edit Ticket :{props.data.id}</DialogTitle>
          ) : (
            <></>
          )}
          {props.dialogAction == EDialogAction.create ? (
            <DialogTitle>Create Ticket </DialogTitle>
          ) : (
            <></>
          )}
          {props.dialogAction == EDialogAction.view ? (
            <DialogTitle>View Ticket :{props.data.id}</DialogTitle>
          ) : (
            <></>
          )}
          <DialogContent>
            <Formik
              enableReinitialize
              validateOnMount
              initialValues={
                props.dialogAction == EDialogAction.create
                  ? {
                    id: +"",
                    passport_no: "",
                    first_name: "",
                    last_name: "",
                    note: "",
                    status: "p",
                  }
                  : ticket
              }
              initialTouched={{ zip: true }}
              validationSchema={Yup.object().shape({
                passport_no: Yup.string()
                  .required("Passport Number is Required")
                  .max(
                    15,
                    "Passport number must not be greater than 15 characters"
                  ),
                note: Yup.string()
                  .max(40, "Note must not be greater than 40 characters")
                  .required("Note is Required"),
                first_name: Yup.string()
                  .max(15, "First name must not be greater than 15 characters")
                  .required("First Name is Required"),
                status: Yup.string()
                  .max(8, "Status must not be greater than 8 characters")
                  .required("Status is Required"),
                last_name: Yup.string()
                  .max(15, "Last name must not be greater than 15 characters")
                  .required("Last Name is Required"),
              })}
              onSubmit={
                props.dialogAction == EDialogAction.create
                  ? createTicket
                  : editTicket
              }
              innerRef={formRef}
            >
              {({
                handleChange,
                handleBlur,
                handleSubmit,
                values,
                touched,
                errors,
              }) => (
                <div className="grid grid-cols-2 mt-3">
                  <div className="flex flex-col space-y-1 mr-6 mb-4 ">
                    <TextField
                      disabled={props.dialogAction != EDialogAction.create}
                      id="first_name"
                      label="First Name"
                      required
                      variant="outlined"
                      onChange={handleChange}
                      value={values.first_name}
                      placeholder="Enter First Name"
                      name="first_name"
                      error={Boolean(touched.first_name && errors.first_name)}
                      helperText={
                        errors.first_name &&
                        touched.first_name &&
                        String(errors.first_name)
                      }
                    />
                  </div>

                  <div className="flex flex-col space-y-1 mr-6 mb-4 ">
                    <TextField
                      disabled={props.dialogAction != EDialogAction.create}
                      id="last_name"
                      variant="outlined"
                      onChange={handleChange}
                      value={values.last_name}
                      placeholder="Enter Last Name"
                      name="last_name"
                      label="Last Name"
                      required
                      error={Boolean(touched.last_name && errors.last_name)}
                      helperText={
                        errors.last_name &&
                        touched.last_name &&
                        String(errors.last_name)
                      }
                    />
                  </div>

                  <div className="flex flex-col space-y-1 mr-6 ">
                    <TextField
                      disabled={props.dialogAction != EDialogAction.create}
                      id="passport_no"
                      label="Passport Id"
                      required
                      variant="outlined"
                      onChange={handleChange}
                      value={values.passport_no}
                      placeholder="Enter Passport Id"
                      name="passport_no"

                      error={Boolean(errors.passport_no && touched.passport_no)}
                      helperText={
                        errors.passport_no &&
                        touched.passport_no &&
                        String(errors.passport_no)
                      }
                    />
                  </div>
                  <div className="flex flex-col space-y-1 mr-6 mb-4">

                    <TextField
                      disabled={props.dialogAction != EDialogAction.create}
                      id="outlined-multiline-flexible"
                      label="Note"
                      
                      multiline
                      maxRows={2}
                      variant="outlined"
                      onChange={handleChange}
                      value={values.note}
                      placeholder="Enter a Note"
                      name="note"
                      error={Boolean(errors.note && touched.note)}
                      helperText={
                        errors.note && touched.note && String(errors.note)
                      }
                    />
                  </div>

                  <div className="flex flex-col space-y-1 mr-6 mb-4">
                    <div>
                      <FormControl size="small">
                        <InputLabel id="select-standard-label">Status</InputLabel>
                        <Select
                          disabled={props.dialogAction == EDialogAction.view}
                          style={{ width: 250, fontSize: 14 }}
                          id="status"
                          label="Status"
                          labelId="select-standard-label"
                          defaultValue="p"
                          value={values.status}
                          onChange={handleChange}
                          name="status"
                          size="medium"
                          color={values.status == "p" ? "primary" : "success"}
                          error={Boolean(touched.status && errors.status)}
                        >
                          <MenuItem value={"p"}>Processing</MenuItem>
                          <MenuItem value={"c"}>Completed</MenuItem>
                        </Select>
                      </FormControl>
                      <FormHelperText style={{ color: "red" }}>
                        {errors.status &&
                          touched.status &&
                          String(errors.status)}
                      </FormHelperText>
                    </div>
                  </div>
                  <div>
                    <div className="flex py-3 px-3 space-x-4 justify-center">
                      {props.dialogAction != EDialogAction.view ? (
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            handleSubmit();
                          }}
                        >
                          {props.dialogAction == EDialogAction.edit ? "Update" : "Create"}
                        </Button>
                      ) : null}
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                          handleClose();
                        }}
                      >
                        Close
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            </Formik>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default TicketDialogBox;
